export default function translateAuthError (errCode, isRegister = false) {
  const fbErrors = {
    'auth/email-change-needs-verification': 'Seu e-mail não foi verificado. Qualquer dúvida fale com o nosso suporte.',
    'auth/email-already-in-use': 'O e-mail já consta em nossa base de dados. Qualquer dúvida fale com o nosso suporte.',
    'auth/invalid-email': 'O endereço de e-mail é inválido! Por favor, corrija e tente novamente.',
    'auth/wrong-password': 'Senha inválida! Por favor, corrija e tente novamente.',
    'auth/timeout': 'O tempo limite foi excedido. Por favor, tente novamente ou fale com o nosso suporte.',
    'auth/too-many-requests': 'Houveram muitas tentativas de acesso! Por favor, fale com o nosso suporte.',
    'auth/unverified-email': 'O e-mail não foi verificado! Por favor, tente novamente ou fale com o nosso suporte.',
    'auth/user-not-found': 'O e-mail não foi encontrado! Por favor, corrija e tente novamente ou fale com o nosso suporte.',
  }

  return fbErrors[errCode] || `Não foi possível ${isRegister ? 'criar' : 'acessar'} a conta. Por favor, tente novamente ou fale com o nosso suporte. (Erro: ${errCode})`
}
